<template>
 	<b-container v-if="$can('view-vendors') || $can('view-all')" fluid>
        <b-row class="page-title">
            <b-container fluid>
                <b-row>
                    <b-col>
                        <h3>Vendors</h3>
                    </b-col>
                    <b-col class="buttons-create text-right">
                        <b-button variant="outline-primary" size="sm" @click="openModal('create-vendor')">New Vendor</b-button>
                        <b-button v-if="$can('execute-export') || $can('view-all')" variant="outline-primary" size="sm" @click="openModal('export-columns')">Export</b-button>
                        <b-button variant="outline-primary" size="sm" @click="openModal('adjust-columns')"><i class="fas fa-columns"></i></b-button>
                    </b-col>
                </b-row>
                <hr>
            </b-container>
        </b-row>

        <b-row>
            <b-container fluid>
                <b-row>
                    <b-col cols="3">
                        <b-form-group>
                          <b-input-group size="sm">
                            <b-form-input
                              v-model="tables.vendors.filter"
                              type="search"
                              id="filterInput"
                              placeholder="Type to Search"
                              debounce="500"
                            ></b-form-input>
                            <b-input-group-append>
                              <b-button :disabled="!tables.vendors.filter" @click="tables.vendors.filter = ''">Clear</b-button>
                            </b-input-group-append>
                          </b-input-group>
                        </b-form-group>
                    </b-col>

                    <b-col cols="8" />

                    <b-col cols="1">
                        <b-form-group>
                          <b-form-select
                            v-model="tables.vendors.perPage"
                            id="perPageSelect"
                            size="sm"
                            :options="tables.vendors.pageOptions"
                          ></b-form-select>
                        </b-form-group>
                    </b-col>
                </b-row>

                <b-row class="row-vendors-table">
                    <b-container fluid>
                        <b-table
                            v-if="tables.vendors.ready"
                            ref="vendorsTable"
                            :key="tables.vendors.key"
                            class="vendors-table"
                            responsive bordered striped
                            hover no-border-collapse
                            sticky-header="calc(100vh - 250px)"
                            head-variant="light"
                            :items="vendorsProvider"
                            :fields="visibleFields"
                            :sort-by.sync="tables.vendors.sortBy"
                            :sort-desc.sync="tables.vendors.sortDesc"
                            :per-page="tables.vendors.perPage"
                            :current-page.sync="tables.vendors.currentPage"
                            :filter="tables.vendors.filter"
                            :busy.sync="tables.vendors.isBusy"
                        >

                            <template v-slot:table-busy>
                                <div class="text-center text-default my-2">
                                    <b-spinner class="align-middle"></b-spinner>
                                    <strong>Loading...</strong>
                                </div>
                            </template>

                            <template v-slot:cell(name)="row">
                                <b-link :to="{name: 'VendorDetail', params: { id: row.item.id } }">{{ row.item.name }}</b-link>
                            </template>

                            <template v-slot:cell(sales_rep_id)="row">
                                <span v-if="row.item.sales_rep">{{ row.item.sales_rep.name }}</span>
                            </template>

                            <template v-slot:cell(email)="row">
                                <span v-if="row.item.email"><b-link @click="openModal('create-email', row.item)">{{ row.item.email }}</b-link></span>
                            </template>

                            <template v-slot:cell(balance)="row">
                                <span>$ {{ numberWithCommas(row.item.balance) || '0.00' }}</span>
                            </template>

                            <template v-slot:cell(actions)="row">
                                <b-container class="actions-icons" fluid>
                                    <b-row>
                                        <b-col>
                                            <b-link @click="openModal('edit-vendor', row.item)"><i class="fas fa-edit"></i></b-link>
                                        </b-col>
                                        <b-col v-if="$can('view-all') || $can('delete-vendors')">
                                            <b-link @click="deleteConfirm(row.item.name, row.item.id)" class="icon-danger"><i class="fas fa-trash-alt"></i></b-link>
                                        </b-col>
                                    </b-row>
                                </b-container>
                            </template>
                        </b-table>
                    </b-container>
                </b-row>

                <b-row>
                    <b-col cols="6">
                        {{ pageTotals }}
                    </b-col>

                    <b-col cols="6" class="my-1">
                        <b-pagination
                          v-model="tables.vendors.currentPage"
                          :total-rows="tables.vendors.totalRows"
                          :per-page="tables.vendors.perPage"
                          align="fill"
                          size="sm"
                          class="my-0"
                        ></b-pagination>
                    </b-col>
                </b-row>
            </b-container>
        </b-row>

        <modal-create-vendor
            v-if="modals['create-vendor'].active"
            @getRow="refreshVendorsTable"
        />

        <modal-edit-vendor
            v-if="modals['edit-vendor'].active"
            :row="modals['edit-vendor'].row"
            @getRow="refreshVendorsTable"
        />

        <modal-adjust-columns
            v-if="modals['adjust-columns'].active"
            :fields="modals['adjust-columns'].fields"
            @saveColSaves="saveColSaves"
        />

        <modal-export-columns
            v-if="modals['export-columns'].active"
            :fields="modals['export-columns'].fields"
            :ignores="modals['export-columns'].ignores"
            @exportExcel="exportExcel"
        />
    </b-container>
</template>

<script>
    import Treeselect from '@riophae/vue-treeselect'
    import '@riophae/vue-treeselect/dist/vue-treeselect.css'
    import ModalCreatevendor from './modals/CreateVendor'
    import ModalEditVendor from './modals/EditVendor'
    import ModalAdjustColumns from '../../common/modals/AdjustColumns'
    import ModalExportColumns from '../../common/modals/ExportColumns'
    import tableColumnPreferences from '../../../../mixins/tableColumnPreferences'
 	export default {
    	name: 'vendors',

        mixins: [tableColumnPreferences],

        metaInfo() {
            return {
                title: 'Vendors',
            }
        },

    	components: {
                Treeselect,
                'modal-create-vendor': ModalCreatevendor,
                'modal-edit-vendor': ModalEditVendor,
                'modal-adjust-columns': ModalAdjustColumns,
                'modal-export-columns': ModalExportColumns
    	},
        data() {
            return {
                modals: {
                    'create-vendor': {
                        active: 0
                    },

                    'edit-vendor': {
                        active: 0
                    },

                    'adjust-columns': {
                        active: 0,
                        fields: []
                    },

                    'export-columns': {
                        active: 0,
                        fields: [],
                        ignores: ['actions']
                    }
                },
                tables: {
                    vendors: {
                        filteredItems: [],
                        isBusy: false,
                        totalRows: 0,
                        currentPage: 1,
                        perPage: 20,
                        pageOptions: [20, 50, 100, 500, 1000],
                        sortBy: 'name',
                        sortDesc: false,
                        // sortDirection: 'asc',
                        filter: null,
                        filterCat: '',
                        key: 1,
                        userFields: [],
                        fields: [
                            {
                                key: 'id',
                                label: 'ID',
                                sortable: true,
                                visible: 1
                            },
                            {
                                key: 'name',
                                label: 'Name',
                                sortable: true,
                                visible: 1
                            },
                            {
                                key: 'balance',
                                label: 'Balance',
                                sortable: true,
                                visible: 1
                            },
                            {
                                key: 'last_shipment',
                                label: 'Last Shipment',
                                sortable: true,
                                visible: 1
                            },
                            {
                                key: 'last_po',
                                label: 'Last PO #',
                                sortable: true,
                                visible: 1
                            },
                            {
                                key: 'sku_instock',
                                label: 'SKU (In Stock)',
                                sortable: true,
                                visible: 1
                            },
                            {
                                key: 'sku_outofstock',
                                label: 'SKU (Out Of Stock)',
                                sortable: true,
                                visible: 1
                            },
                            {
                                key: 'actions',
                                label: '',
                                thClass: 'vendors-table-style-actions',
                                visible: 1
                            }
                        ],

                        items: [],
                        ready: 0
                    },
                },

                exports: {
                    cols: []
                }
            }
        },
        methods: {
            exportExcel(cols, keys) {
                let url = 'api/lists/vendors/exportvendors'
                axios.post(url, {
                    search: this.tables.vendors.filter,
                    sortBy: this.tables.vendors.sortBy,
                    sortDesc: this.tables.vendors.sortDesc,
                    cols: cols,
                    keys: keys
                },
                {
                    responseType: 'blob'
                })
                .then((res) => {
                    this.forceFileDownload(res)
                }, () => {
                    this.has_error = true
                })
            },

            forceFileDownload(response){
                const url = window.URL.createObjectURL(new Blob([response.data]))
                const link = document.createElement('a')
                link.href = url
                link.setAttribute('download', 'Vendors_Export_File_' + +new Date() + '.xlsx') //or any other extension
                document.body.appendChild(link)
                link.click()

                this.showAlertBox('success', 'File Generated', 'Vendors export file generated successfully!')
            },

            openModal(modalName, row, extra) {
                let prefix = 'modal-lists-vendors-'
                switch (modalName) {
                    case 'create-vendor':
                        this.modals[modalName].active = 1

                        break
                    case 'edit-vendor':
                        this.modals[modalName].active = 1
                        this.modals[modalName].row = Object.assign({}, row)
                        break
                    case 'adjust-columns':
                        this.modals[modalName].active = 1

                        this.modals[modalName].fields = this.cloneFieldsForAdjust(this.tables.vendors.userFields, this.tables.vendors.fields)

                        break
                    case 'export-columns':
                        this.modals[modalName].active = 1

                        this.modals[modalName].fields = JSON.parse(JSON.stringify(this.tables.vendors.fields.filter(e => !this.modals[modalName].ignores.includes(e.key))))

                        break
                }

                if (modalName == 'adjust-columns' || modalName == 'export-columns') {
                    prefix = 'modal-common-'
                }

                this.$nextTick(() => {
                    this.$bvModal.show(prefix + modalName)
                })
            },

            closeModal(modalName) {
                this.$bvModal.hide(modalName)
            },

            toggleBusy() {
                this.tables.vendors.isBusy = !this.tables.vendors.isBusy ? true : false
            },

            vendorsProvider(ctx) {
                return this.scheduleProviderFetch('vendors', ctx, (latestCtx) => {
                    const normalized = this.normalizeTableProviderContext(latestCtx, this.tables.vendors)
                    let payload = {
                        page: normalized.currentPage,
                        perPage: normalized.perPage,
                        sortBy: normalized.sortBy,
                        sortDesc: normalized.sortDesc,
                        search: normalized.filter
                    }

                    return axios.post('api/lists/vendors/getvendors', payload)
                    .then((res) => {
                        this.tables.vendors.items = res.data.vendors
                        this.tables.vendors.totalRows = res.data.total
                        return res.data.vendors || []
                    }, () => {
                        this.has_error = true
                        return []
                    })
                })
            },

            refreshVendorsTable() {
                if (this.$refs.vendorsTable) {
                    this.$refs.vendorsTable.refresh()
                }
            },

            initVendors() {
                this.tables.vendors.ready = 1
            },

            deleteConfirm(name, rowId) {
                this.$bvModal.msgBoxConfirm('Please confirm that you want to delete: ' + name, {
                        title: 'Delete: ' + name,
                        size: 'sm',
                        buttonSize: 'sm',
                        okVariant: 'danger',
                        okTitle: 'Confirm',
                        cancelTitle: 'Cancel',
                        footerClass: 'p-2',
                        hideHeaderClose: false,
                        centered: true
                })
                .then(value => {
                    if (value) {
                        this.deleteVendor(name, rowId)
                    }
                })
                .catch(err => {
                    // An error occurred
                })
            },

            deleteVendor(name, rowId) {
                let url = 'api/lists/vendors/deletevendor/' + rowId

                axios.get(url, {})
                .then((res) => {
                    if (res.data.status == 'success') {
                        this.showAlertBox('success', 'Delete Vendor', 'Vendor ' + name + ' has been deleted!')
                        this.refreshVendorsTable()
                    } else {
                        this.showAlertBox('danger', 'Delete Failed', res.data.message || 'Cannot delete vendor. It has associated transactions.')
                    }
                }, (error) => {
                    if (error.response && error.response.data && error.response.data.message) {
                        this.showAlertBox('danger', 'Delete Failed', error.response.data.message)
                    } else {
                        this.has_error = true
                    }
                })
            },

            getColSaves() {
                let url = 'api/remembertable/getcolsaves/vendors'
                axios.get(url, {})
                .then((res) => {
                    if (res.data.status == 'success') {
                        if (res.data.colSaves) {
                            const merged = this.mergeColSaves(this.tables.vendors.fields, res.data.colSaves.column_array)
                            if (merged) {
                                this.tables.vendors.userFields = merged
                            }
                        }

                        this.initVendors()
                    }
                }, () => {
                    this.has_error = true
                })
            },

            saveColSaves(fields) {
                const normalized = this.normalizeColumnOrder(fields)
                this.tables.vendors.userFields = normalized
                let url = 'api/remembertable/savecolsaves'
                axios.post(url, {
                    area: 'vendors',
                    fields: this.formatColSavesPayload(normalized)
                })
                .then((res) => {
                    this.forceRerender()
                }, () => {
                    this.has_error = true
                })
            },

            forceRerender() {
                this.tables.vendors.ready = 0
                let tempFields = this.tables.vendors.fields
                this.tables.vendors.fields = []
                this.$nextTick(() => {
                    this.tables.vendors.fields = tempFields
                    this.tables.vendors.ready = 1
                })
            }
        },
    	computed: {
	    	sortOptions() {
                // Create an options list from our fields
                return this.tables.vendors.fields
                    .filter(f => f.sortable)
                    .map(f => {
                        return { text: f.label, value: f.key }
                    })
            },

            pageTotals() {
                let totalRows = this.tables.vendors.totalRows
                let currentPage = this.tables.vendors.currentPage
                let perPage = this.tables.vendors.perPage

                if (!totalRows) {
                    return 'Showing 0 of 0 rows'
                }

                let from = ((currentPage - 1) * perPage) + 1
                let to = Math.min(currentPage * perPage, totalRows)

                return 'Showing ' + from + ' to ' + to + ' of ' + totalRows + ' rows'
            },

            visibleFields() {
                return this.buildVisibleFields(this.tables.vendors.fields, this.tables.vendors.userFields)
            }
	    },
	    mounted() {
            this.getColSaves()

            this.$root.$on('bv::modal::hidden', (bvEvent, modalId) => {
                switch (modalId) {
                    case 'modal-lists-vendors-create-vendor':
                        this.modals['create-vendor'].active = 0

                        break
                    case 'modal-lists-vendors-edit-vendor':
                        this.modals['edit-vendor'].active = 0

                        break
                    case 'modal-common-adjust-columns':
                        this.modals['adjust-columns'].active = 0
                        this.modals['adjust-columns'].fields = []

                        break
                    case 'modal-common-export-columns':
                        this.modals['export-columns'].active = 0
                        this.modals['export-columns'].fields = []

                        break
                }
            })

            // pusher
            Echo.channel('table-vendor-updated')
                .listen('TableVendorUpdated', (e) => {
                    this.getvendors(1)
            })
	    }
  }
</script>
<style lang="scss">
    .vue-treeselect__control {
        // height: calc(1.5em + 0.5rem + 2px);
        // padding-top: 0.25rem;
        // padding-bottom: 0.25rem;
        // padding-left: 0.5rem;
        font-size: 0.875rem !important;

        .vue-treeselect__placeholder, .vue-treeselect__single-value {
            // line-height: 1.5
        }
    }

    .vendors-table {
        height: 75vh;
        font-size: 9pt;

        .vendors-table-style-actions {
            min-width: 120px;

            .actions-icons {
                text-align: center;
                white-space: nowrap;
            }
        }

        .vendors-table-style-phone {
            min-width: 105px;
        }

        .vendors-table-style-th-datetime {
            min-width: 110px;
        }

        .vendors-table-style-td-datetime {
            text-align: center;
        }
    }
</style>
